import { Check, X } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

export const MonthlySupport = () => {
  const { t } = useLang();
  const c = t.care;
  return (
    <section id="support" data-testid="monthly-support-section" className="py-20 md:py-24 bg-[#FAFAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>{c.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight text-navy-900">
            {c.title}
          </h2>
          <p className="mt-5 text-lg text-charcoal-700 leading-relaxed">{c.sub}</p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5 items-stretch">
          {c.plans.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.08} className="h-full">
              <div
                data-testid={`care-plan-${i}`}
                className="group relative overflow-hidden h-full flex flex-col rounded-2xl border border-navy-100 bg-white p-7 shadow-[0_2px_12px_rgba(6,16,32,0.04)] hover:shadow-xl transition-shadow duration-300"
              >
                <span className="absolute inset-x-0 top-0 h-1 brand-gradient opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <h3 className="font-display text-xl font-semibold text-navy-900">{p.name}</h3>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="font-display text-3xl font-bold gradient-text">{p.price}</span>
                  <span className="text-sm text-charcoal-700/60">{p.per}</span>
                </div>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {p.includes.map((inc) => (
                    <li key={inc} className="flex items-start gap-2.5 text-[15px] text-charcoal-700">
                      <Check size={17} className="mt-0.5 shrink-0 text-gold-600" aria-hidden />
                      {inc}
                    </li>
                  ))}
                </ul>

                <div className="mt-5 flex items-start gap-2.5 rounded-xl bg-[#FAFAFC] border border-navy-100 p-3 text-sm text-charcoal-700/80">
                  <X size={16} className="mt-0.5 shrink-0 text-charcoal-700/50" aria-hidden />
                  <span><span className="font-semibold text-navy-900">{c.notIncluded}</span>{p.excludes}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
